import { Component, Inject, Input, OnInit } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { SessionService } from 'src/app/lib/shared/services/session.service';
import { IssueAuditWrapper } from '../../../classes';
import { HISTORY_PROVIDER_SERVICE, ISSUE_AUDIT_WRAPPER_PROVIDER } from '../../../interfaces';
import { IssueAuditService } from '../../../services/issue-audit.service';
import { IssueHistoryDialogComponentService } from '../../dialog/issue-history-dialog/issue-history-dialog-component-service';
import { IssueAuditWrapperComponentService } from './issue-audit-wrapper-service';

@Component({
  selector: 'app-issue-audit-wrapper',
  templateUrl: './issue-audit-wrapper.component.html',
  styleUrls: ['./issue-audit-wrapper.component.css'],
  providers: [
    { provide: ISSUE_AUDIT_WRAPPER_PROVIDER, useClass: IssueAuditWrapperComponentService }
  ]
})
export class IssueAuditWrapperComponent implements OnInit {

  @Input() set wrapper(wrapper: IssueAuditWrapper) {
    this.issueAuditWrapperComponentService.setIssueAuditWrapper(wrapper);
  }

  @Input() isFirstEntry: boolean = false;
  @Input() isLastEntry: boolean = false;

  rightsMap = {
    "edit_datasets": false
  };

  constructor(
    @Inject(HISTORY_PROVIDER_SERVICE) private _issueHistoryDialogComponentService: IssueHistoryDialogComponentService,
    @Inject(ISSUE_AUDIT_WRAPPER_PROVIDER) public issueAuditWrapperComponentService: IssueAuditWrapperComponentService,
    private _issueAuditService: IssueAuditService,
    private _sessionService: SessionService
  ) { }

  deleteIssueAuditWrapper() {
    this.issueAuditWrapperComponentService.issueAuditWrapper$
      .pipe(switchMap(wrapper => this._issueHistoryDialogComponentService.deleteIssueAuditWrapper(wrapper)))
      .toPromise();
  }

  initRights(soft: boolean = true) {
    for (let index in this.rightsMap) this._sessionService.hasRight(index, soft).subscribe(result => this.rightsMap[index] = result);
  }

  markIssueAuditWrapperAsCreated() {
    this.issueAuditWrapperComponentService.issueAuditWrapper$.pipe(switchMap(x => this._issueAuditService.markIssueAuditWrapperAsCreated(x.guid).pipe(map(_ => x))))
      .subscribe({
        next: (issueAuditWrapper: IssueAuditWrapper) => {
          issueAuditWrapper.specialAction = 1;
        }
      });
  }

  markIssueAuditWrapperAsFinished() {
    this.issueAuditWrapperComponentService.issueAuditWrapper$.pipe(switchMap(x => this._issueAuditService.markIssueAuditWrapperAsFinished(x.guid).pipe(map(_ => x))))
      .subscribe({
        next: (issueAuditWrapper: IssueAuditWrapper) => {
          issueAuditWrapper.specialAction = 3;
          issueAuditWrapper.running = false;
        }
      });
  }

  ngOnInit(): void {
    this.initRights();
  }

}
